module.exports = __webpack_public_path__ + "media/audio25.25a00b0c.mp3";